import createFilterOptions from 'react-select-fast-filter-options'
import { createSelector } from 'reselect'
import config from '../config'
import { AppState } from '../store'
import { AscendingLabelIndex } from '../utils/js-search/ascendingLabelIndex'

export const buildInventoryLocationOptionsIndex = createSelector(
  (s: AppState) => s.current.inventoryLocationOptions.values,
  options => {
    if (config.DEV) console.log('Rebuilding inventory location index')

    // use js-search index on both label AND value
    // Use case: Some users scan inventory location barcodes which are encoded with the inventory location id
    const indexes = ['label', 'value']

    // build quick search index for Inventory Location options
    // docs: https://github.com/bvaughn/react-select-fast-filter-options
    return createFilterOptions({ options, indexes })
  }
)

export const buildInventoryLocationOptionsIndexNameOnly = createSelector(
  (s: AppState) => s.current.inventoryLocationOptions.values,
  options => {
    if (config.DEV) console.log('Rebuilding inventory location index (name only)')

    // use js-search index on both label AND value
    // Use case: Some users scan inventory location barcodes which are encoded with the inventory location id
    const indexes = ['label']

    // Make sure locations are ordered by name, as opposed to the default `UnorderedSearchIndex`
    const searchIndex = new AscendingLabelIndex()

    // build quick search index for Inventory Location options
    // docs: https://github.com/bvaughn/react-select-fast-filter-options
    return createFilterOptions({ options, indexes, searchIndex })
  }
)
